// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { featuredCategoriesStyles } from "@awc/App/Widgets/FeaturedCategories/FeaturedCategories";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, ellipsis, xScreen } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

featuredCategoriesStyles.titleTypographyStyles = {
    wrapper: {
        css: css`
            justify-content: center;
            margin-bottom: 16px;
        `,
    },
    title: {
        variant: "h2",
        css: css`
            margin-bottom: 0;
            text-align: center;
        `,
    },
};

featuredCategoriesStyles.description = {
    size: fontConfig.fontSize.regular,
    weight: fontConfig.weight.regular,
    lineHeight: fontConfig.lineHeight.regular,
    css: css`
        text-align: center;
        margin-bottom: 0;
        & > ${TypographyStyle} {
            font-size: inherit;
            font-weight: inherit;
            line-height: inherit;
            margin-bottom: 0;
        }
    `,
};

featuredCategoriesStyles.categoriesContainer = {
    css: css`
        display: grid;
        grid-template-columns: repeat(auto-fit, 149px);
        gap: 16px 26px;
        justify-content: start;
        margin-top: 48px;
        ${xScreen("lte", "xs")} {
            grid-template-columns: repeat(2, minmax(0, 164px));
            gap: 16px;
        }
    `,
};

featuredCategoriesStyles.categoryImage = {
    css: css`
        width: 149px;
        height: 100px;

        img {
           object-fit: contain;
        }
    `,
};

featuredCategoriesStyles.clickableImage = {
    css: css`
        margin-bottom: 12px;
        box-shadow: 0 1px 3px 2px transparent;
        transition: box-shadow 200ms ease-in-out;
        &:hover {
            box-shadow: 0 1px 3px 2px ${color("primary.main", 0.35)};
        }
    `,
}

featuredCategoriesStyles.categoryLink = {
    typographyProps: {
        size: fontConfig.fontSize.regular,
        weight: fontConfig.weight.bold,
        lineHeight: fontConfig.lineHeight.xSmall,
        css: css`
            ${ellipsis(2)}
        `,
    },
    css: css`
        display: flex;
        justify-content: center;
        text-align: center;
    `,
};
